export default [
    {
        path: '/gerencia/servidores', component: () => import('./components/Page'), name: 'gerencia.servidor.page', children: [
            {path: '', component: () => import('./components/List'), name: 'gerencia.servidor'},
            {path: ':id', component: () => import('./components/Show'), name: 'gerencia.servidor.show'},
        ]
    }
]
